/**
 * HSeparator - Horizontal separator component
 *
 * Alias for Separator with horizontal orientation
 *
 * @example
 * ```tsx
 * <HSeparator my={4} />
 * ```
 */

import { Separator, type SeparatorProps } from "./Separator";

export const HSeparator = (props: SeparatorProps) => {
  return <Separator orientation="horizontal" {...props} />;
};

